
"use client";

import Link from "next/link";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Image from "next/image";
import styles from "./nav.module.scss";
import { useAuth } from "@/providers/auth-context";

const TopNav = () => {
  const { authenticated, logout } = useAuth();

  return (
    <Navbar collapseOnSelect expand="md" className={styles.topnav}>
      <Container>
        <Navbar.Brand href="/">
          <Image
            src="/logos/peatsense-logo-beta.png"
            priority
            width="0"
            height="0"
            sizes="100vw"
            className="tw-h-10 tw-w-auto"
            alt="Peat Sense"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="tw-me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            {authenticated ? (
              <></>
            ) : (
              <>
                <Nav.Link href="/map">Map</Nav.Link>
                <Nav.Link href="/info-page">MapWiki</Nav.Link>
                <Nav.Link href="/news">News</Nav.Link>
                <Nav.Link href="/glossary">Glossary</Nav.Link>
                <Nav.Link href="/directory">Directory</Nav.Link>
              </>
            )}
            <Nav.Link href="/on-demand-services">
              API
            </Nav.Link>
            <Nav.Link href="/acknowledgements">
              Acknowledgements
            </Nav.Link>
            <Nav.Link href="https://www.ai2peat.ie" target="_blank">
              AI2Peat
            </Nav.Link>
          </Nav>
          <Nav>
            {authenticated ? (
              <Button variant="outline-primary" onClick={() => logout()}>
                Logout
              </Button>
            ) : (
              <>
                <Nav.Link href="/register" className="tw-mr-4">
                  Signup
                </Nav.Link>
                <Link href="/login" passHref>
                  <Button variant="primary">Login</Button>
                </Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};



export default TopNav;
